
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/dmservices/api/v1'; // Default to your local API if not set

console.log("API Base URL:", API_BASE_URL);

// Create an Axios instance with the base URL
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false, 
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Generic function to handle errors
const handleError = (error: any) => {
  console.error("API Error:", error.response ? error.response.data : error.message);
  throw error;
};

export const sendOtp = async (name: string, mobileNumber: string, watsUpNumber: string, email: string, country: string) => {
  try {
    const response = await apiClient.post('/otp/send', { name, mobileNumber, watsUpNumber, email, country});
    //alert("response");
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const verifyOtp = async (name: string, mobileNumber: string, watsUpNumber: string, email: string, otp: string) => {
  try {
    const response = await apiClient.post(`/otp/verify?otp=${otp}`, { name, mobileNumber, watsUpNumber, email });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const userSave = async (name: string, mobileNumber: string, watsUpNumber: string, email: string, country: string, state: string, district: string, city: string, pinCode: string, status: string) => {
  try {
    const response = await apiClient.post('/user/saveverify', { name, mobileNumber, watsUpNumber, email, country, state, district, city, pinCode, status });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const contactInfoSave = async (name: string, mobileNumber: string, whatsapp: string, email: string, firstName: string, lastName: string, contactNumber: string, gender: string, financeDevelopment: string, purchase: string, joinWithUs: string, emailAddress: string, city: string, district: string, state: string, pinCode: string, about: string, dateOfBirth: String) => {
  try {
    const status = 'CONTACT_INFO_COMPLETED';
    const response = await apiClient.post('/user/update', {name, mobileNumber, whatsapp, email,
      firstName,
      lastName,
      contactNumber,
      gender,
      financeDevelopment,
      purchase,
      joinWithUs,
      emailAddress,
      city,
      district,
      state,
      pinCode,
      about, 
      status
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const sendIntroVideo = async (name: string, mobileNumber: string, whatsapp: string, email: string) => {
  try {
    const response = await apiClient.post('/user/introVideo', { name, mobileNumber, whatsapp, email });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateDecisionSurvey = async (mobileNumber: string, decision: string) => {
  try {
    const status = 'SURVAY_COMPLETED';
    const response = await apiClient.post('/user/updateDecisionSurvey', { mobileNumber, decision, status });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateOccupation = async (mobileNumber: string, occupation: string) => {
  try {
    const status = 'OCCUPATION_COMPLETED';
    const response = await apiClient.post('/user/updateOccupation', { mobileNumber, occupation, status });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const sendCntVideo = async (name: string, mobileNumber: string, whatsapp: string, email: string) => {
  try {
    const response = await apiClient.post('/user/cntVideo', { name, mobileNumber, whatsapp, email });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateVideoForm = async (mobileNumber: string, whatsapp: string, videoName: string, status: String) => {
  try {
    const response = await apiClient.post('/user/updateVideo', { mobileNumber, whatsapp, videoName, status });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export async function createContact(body: {
  firstName: string; middleName?: string; lastName?: string; mobile: string; job: string; assignTo?: string
}) {
  const { data } = await apiClient.post("/user-details/contacts", body);
  return data;
}

export async function uploadExcel_old(file: File) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post("/user-details/upload-excel", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export const uploadExcel = (
    file: File,
    onProgress?: (percent: number) => void
  ) => {
    const formData = new FormData();
    formData.append("file", file);

    return apiClient.post("/user-details/upload-excel", formData, {
      headers: { "Content-Type": "multipart/form-data" },

      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;

        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        
        if (onProgress) onProgress(percent);
      },
    }).then(res => res.data);
  };

export async function getAssignToList() {
  const res = await apiClient.get("/auth/assign-users");//alert(res.ok);
  //if (!res.ok) throw new Error("Failed to load users");
  //alert(res.data);
  return res.data;
}
